/* Triomi Theme JS — auto-extracted from prototype */


/* ─────────────────────────────────────────
   1. SCROLL PROGRESS BAR
──────────────────────────────────────── */
const bar = document.getElementById('progress-bar');
function updateBar() {
  const max = document.documentElement.scrollHeight - window.innerHeight;
  bar.style.width = (window.scrollY / max * 100) + '%';
}
window.addEventListener('scroll', updateBar, {passive:true});

/* ─────────────────────────────────────────
   2. NAV: add class on scroll
──────────────────────────────────────── */
const nav = document.getElementById('nav');
function updateNav() {
  nav.classList.toggle('scrolled', window.scrollY > 60);
}
window.addEventListener('scroll', updateNav, {passive:true});
updateNav();

/* ─────────────────────────────────────────
   3. INTERSECTION OBSERVER — reveal
──────────────────────────────────────── */
const io = new IntersectionObserver((entries) => {
  entries.forEach(e => {
    if (!e.isIntersecting) return;
    e.target.classList.add('in');

    // stagger checklist items
    if (e.target.classList.contains('about-left') || e.target.classList.contains('split-content')) {
      const items = e.target.querySelectorAll('.checklist li');
      items.forEach((li, i) => {
        setTimeout(() => li.classList.add('in'), 300 + i * 80);
      });
    }

    // image clip reveal
    if (e.target.id === 'about-img') {
      e.target.classList.add('in');
    }

    io.unobserve(e.target);
  });
}, { threshold: 0.12 });

document.querySelectorAll('.rv, .rv-left, .rv-right').forEach(el => io.observe(el));

/* ─────────────────────────────────────────
   4. ABOUT SECTION: clip-path reveal
──────────────────────────────────────── */
const aboutLeft = document.querySelector('.about-left');
const aboutImg  = document.querySelector('.about-right');
const aboutIO = new IntersectionObserver((entries) => {
  entries.forEach(e => {
    if (e.isIntersecting) {
      aboutLeft.classList.add('in');
      aboutImg.classList.add('in');
      // also stagger checklist
      const items = aboutLeft.querySelectorAll('.checklist li');
      items.forEach((li, i) => setTimeout(() => li.classList.add('in'), 400 + i * 90));
      aboutIO.disconnect();
    }
  });
}, { threshold: 0.15 });
if (aboutLeft) aboutIO.observe(aboutLeft);

/* ─────────────────────────────────────────
   5. FEATURE CARDS — staggered
──────────────────────────────────────── */
const featIO = new IntersectionObserver((entries) => {
  entries.forEach(e => {
    if (e.isIntersecting) {
      const feats = document.querySelectorAll('.feat');
      feats.forEach((f, i) => setTimeout(() => f.classList.add('in'), i * 80));
      featIO.disconnect();
    }
  });
}, { threshold: 0.1 });
const featGrid = document.querySelector('.features-grid');
if (featGrid) featIO.observe(featGrid);

/* ─────────────────────────────────────────
   6. REVIEW CARDS — staggered
──────────────────────────────────────── */
const revIO = new IntersectionObserver((entries) => {
  entries.forEach(e => {
    if (e.isIntersecting) {
      const reviews = document.querySelectorAll('.review');
      reviews.forEach((r, i) => setTimeout(() => r.classList.add('in'), i * 120));
      revIO.disconnect();
    }
  });
}, { threshold: 0.1 });
const revGrid = document.querySelector('.reviews-grid');
if (revGrid) revIO.observe(revGrid);

/* ─────────────────────────────────────────
   7. PRICING CARDS — staggered
──────────────────────────────────────── */
const priceIO = new IntersectionObserver((entries) => {
  entries.forEach(e => {
    if (e.isIntersecting) {
      const cards = document.querySelectorAll('.price-card');
      cards.forEach((c, i) => setTimeout(() => c.classList.add('in'), i * 100));
      priceIO.disconnect();
    }
  });
}, { threshold: 0.1 });
const priceGrid = document.querySelector('.pricing-grid');
if (priceGrid) priceIO.observe(priceGrid);

/* ─────────────────────────────────────────
   8. SECOND CHECKLIST (split-content)
──────────────────────────────────────── */
document.querySelectorAll('.split-content').forEach(sc => {
  const scIO = new IntersectionObserver((entries) => {
    entries.forEach(e => {
      if (e.isIntersecting) {
        const items = sc.querySelectorAll('.checklist li');
        items.forEach((li, i) => setTimeout(() => li.classList.add('in'), 300 + i * 90));
        scIO.disconnect();
      }
    });
  }, { threshold: 0.2 });
  scIO.observe(sc);
});

/* ─────────────────────────────────────────
   9. COUNTER ANIMATION
──────────────────────────────────────── */
function animateCount(el) {
  const target  = parseFloat(el.dataset.count);
  const prefix  = el.dataset.prefix  || '';
  const suffix  = el.dataset.suffix  || '';
  const decimals= parseInt(el.dataset.decimals || 0);
  const dur = 1800;
  const start = performance.now();
  function tick(now) {
    const p = Math.min((now - start) / dur, 1);
    const ease = 1 - Math.pow(1 - p, 3);
    const val = (target * ease).toFixed(decimals);
    el.textContent = prefix + val + suffix;
    if (p < 1) requestAnimationFrame(tick);
  }
  requestAnimationFrame(tick);
}

const countIO = new IntersectionObserver((entries) => {
  entries.forEach(e => {
    if (e.isIntersecting && e.target.dataset.count) {
      animateCount(e.target);
      countIO.unobserve(e.target);
    }
  });
}, { threshold: 0.5 });
document.querySelectorAll('[data-count]').forEach(el => countIO.observe(el));

/* ─────────────────────────────────────────
   10. PARALLAX: cinematic bg
──────────────────────────────────────── */
const cinEl = document.getElementById('cinematic');
const cinBg = document.getElementById('cin-bg');
function parallaxCinematic() {
  if (!cinEl || !cinBg) return;
  const rect = cinEl.getBoundingClientRect();
  const center = rect.top + rect.height / 2 - window.innerHeight / 2;
  const offset = center * 0.15;
  cinBg.style.transform = `translateY(${offset}px)`;
}
window.addEventListener('scroll', parallaxCinematic, {passive:true});

/* ─────────────────────────────────────────
   11. PARALLAX: hero bg
──────────────────────────────────────── */
const heroBg = document.querySelector('.hero-bg');
function parallaxHero() {
  if (!heroBg) return;
  const offset = window.scrollY * 0.3;
  heroBg.style.transform = `translateY(${offset}px) scale(1.08)`;
}
window.addEventListener('scroll', parallaxHero, {passive:true});

/* ─────────────────────────────────────────
   12. IMAGE TILT on mouse move
──────────────────────────────────────── */
document.querySelectorAll('.split-img, .about-right').forEach(container => {
  const img = container.querySelector('img');
  if (!img) return;
  container.addEventListener('mousemove', (e) => {
    const r = container.getBoundingClientRect();
    const x = (e.clientX - r.left) / r.width  - 0.5;
    const y = (e.clientY - r.top)  / r.height - 0.5;
    img.style.transform = `scale(1.04) rotateY(${x * 4}deg) rotateX(${-y * 4}deg)`;
  });
  container.addEventListener('mouseleave', () => {
    img.style.transform = 'scale(1) rotateY(0) rotateX(0)';
  });
});

/* ─────────────────────────────────────────
   13. MAGNETIC BUTTONS
──────────────────────────────────────── */
document.querySelectorAll('.hero-cta, .nav-cta, .btn-teal, .price-btn').forEach(btn => {
  btn.addEventListener('mousemove', (e) => {
    const r = btn.getBoundingClientRect();
    const x = (e.clientX - r.left - r.width  / 2) * 0.25;
    const y = (e.clientY - r.top  - r.height / 2) * 0.25;
    btn.style.transform = `translate(${x}px, ${y}px)`;
  });
  btn.addEventListener('mouseleave', () => {
    btn.style.transform = '';
    btn.style.transition = 'transform .4s cubic-bezier(.16,1,.3,1)';
    setTimeout(() => btn.style.transition = '', 400);
  });
});

/* ─────────────────────────────────────────
   14. HOVER: feat-title underline draw
──────────────────────────────────────── */
// Already handled via CSS

/* ─────────────────────────────────────────
   15. TEXT SPLIT ANIMATION on about-h2
──────────────────────────────────────── */
// Word-by-word reveal on large headings when in view
function splitReveal(el, delay=0) {
  // Replace <br> with space so words don't merge
  const raw = el.innerHTML.replace(/<br\s*\/?>/gi, ' ');
  const tmp = document.createElement('div');
  tmp.innerHTML = raw;
  const text = tmp.textContent;
  const words = text.split(/\s+/).filter(Boolean);
  el.innerHTML = words.map(w =>
    `<span style="display:inline-block;overflow:hidden;vertical-align:bottom"><span class="word-inner" style="display:inline-block;transform:translateY(100%);transition:transform .6s cubic-bezier(.16,1,.3,1)">${w}</span></span>`
  ).join(' ');
  return el.querySelectorAll('.word-inner');
}

const h2els = document.querySelectorAll('.about-h2, .features-h2, .pricing-h2, .reviews-h2');
h2els.forEach(h2 => {
  const words = splitReveal(h2);
  const h2IO = new IntersectionObserver((entries) => {
    entries.forEach(e => {
      if (e.isIntersecting) {
        words.forEach((w, i) => {
          setTimeout(() => { w.style.transform = 'translateY(0)'; }, i * 60);
        });
        h2IO.disconnect();
      }
    });
  }, { threshold: 0.3 });
  h2IO.observe(h2);
});

/* ─────────────────────────────────────────
   HOW IT WORKS stagger
──────────────────────────────────────── */
const howIO = new IntersectionObserver((entries) => {
  entries.forEach(e => {
    if (e.isIntersecting) {
      document.querySelectorAll('.how-step').forEach((s,i) =>
        setTimeout(() => s.classList.add('in'), i * 100));
      howIO.disconnect();
    }
  });
}, { threshold: 0.1 });
const howGrid = document.querySelector('.how-steps');
if (howGrid) howIO.observe(howGrid);

/* ─────────────────────────────────────────
   GALLERY REVEAL (missing on live site — no design-mode class)
──────────────────────────────────────── */
const galleryIO = new IntersectionObserver((entries) => {
  entries.forEach(e => {
    if (e.isIntersecting) {
      e.target.classList.add('in');
      galleryIO.unobserve(e.target);
    }
  });
}, { threshold: 0.05 });
document.querySelectorAll('.gallery-item').forEach(el => galleryIO.observe(el));

/* ─────────────────────────────────────────
   GALLERY FILTER
──────────────────────────────────────── */
document.querySelectorAll('.gf-btn').forEach(btn => {
  btn.addEventListener('click', () => {
    document.querySelectorAll('.gf-btn').forEach(b => b.classList.remove('active'));
    btn.classList.add('active');
    const filter = btn.dataset.filter;
    document.querySelectorAll('.gallery-item').forEach(item => {
      const show = filter === 'all' || item.dataset.cat === filter;
      item.classList.toggle('filtered-out', !show);
    });
  });
});

/* ─────────────────────────────────────────
   CARD EDITOR — live preview
──────────────────────────────────────── */
const typeData = {
  '⚡': { color:'#f5e642', bg:'linear-gradient(135deg,#fff9cc 0%,#f5e690 100%)' },
  '🔥': { color:'#f56442', bg:'linear-gradient(135deg,#fff0e0 0%,#f5b090 100%)' },
  '💧': { color:'#42a4f5', bg:'linear-gradient(135deg,#e0f0ff 0%,#90c4f5 100%)' },
  '🌿': { color:'#42c464', bg:'linear-gradient(135deg,#e0ffe0 0%,#90e4a0 100%)' },
  '✨': { color:'#c442f5', bg:'linear-gradient(135deg,#f0e0ff 0%,#c490f5 100%)' },
  '🌑': { color:'#555',   bg:'linear-gradient(135deg,#e8e8e8 0%,#b0b0b0 100%)' },
};
let currentType = '⚡';

function updateCard() {
  const name = document.getElementById('card-name-input')?.value || 'MEIN NAME';
  const hp   = document.getElementById('hp-range')?.value || '150';
  const atk1n = document.getElementById('atk1-name')?.value || '';
  const atk1d = document.getElementById('atk1-dmg')?.value  || '0';
  const atk2n = document.getElementById('atk2-name')?.value || '';
  const atk2d = document.getElementById('atk2-dmg')?.value  || '0';
  const td = typeData[currentType] || typeData['⚡'];

  const el = (id) => document.getElementById(id);
  if (el('tcg-name'))     el('tcg-name').textContent     = name.toUpperCase();
  if (el('tcg-hp-val'))   el('tcg-hp-val').textContent   = hp;
  if (el('tcg-atk1-name'))el('tcg-atk1-name').textContent= atk1n;
  if (el('tcg-atk1-dmg')) el('tcg-atk1-dmg').textContent = atk1d;
  if (el('tcg-atk2-name'))el('tcg-atk2-name').textContent= atk2n;
  if (el('tcg-atk2-dmg')) el('tcg-atk2-dmg').textContent = atk2d;
  if (el('tcg-bg'))        el('tcg-bg').style.background  = td.bg;
  if (el('tcg-type-icon')){ el('tcg-type-icon').textContent = currentType; el('tcg-type-icon').style.background = td.color; }
  if (el('tcg-atk1-cost')) el('tcg-atk1-cost').textContent = currentType;
  if (el('tcg-atk2-cost')) el('tcg-atk2-cost').textContent = currentType + currentType;
}

// wire inputs
['card-name-input','atk1-name','atk1-dmg','atk2-name','atk2-dmg'].forEach(id => {
  const el = document.getElementById(id);
  if (el) el.addEventListener('input', updateCard);
});
const hpRange = document.getElementById('hp-range');
if (hpRange) {
  hpRange.addEventListener('input', () => {
    document.getElementById('hp-val').textContent = hpRange.value;
    updateCard();
  });
}

// type buttons
document.querySelectorAll('.type-btn').forEach(btn => {
  btn.addEventListener('click', () => {
    document.querySelectorAll('.type-btn').forEach(b => b.classList.remove('active'));
    btn.classList.add('active');
    currentType = btn.dataset.type;
    updateCard();
  });
});

// stand color swatches
document.querySelectorAll('.color-swatch').forEach(sw => {
  sw.addEventListener('click', () => {
    document.querySelectorAll('.color-swatch').forEach(s => s.classList.remove('active'));
    sw.classList.add('active');
    const stand = document.getElementById('stand-preview');
    if (stand) stand.style.background = sw.dataset.color;
  });
});

// image upload
const uploadInput = document.getElementById('artwork-upload');
if (uploadInput) {
  uploadInput.addEventListener('change', (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = (ev) => {
      const img = document.getElementById('tcg-art-img');
      const placeholder = document.getElementById('tcg-art-placeholder');
      const previewImg = document.getElementById('upload-preview-img');
      const uploadLabel = document.getElementById('upload-label');
      if (img) { img.src = ev.target.result; img.style.display = 'block'; }
      if (placeholder) placeholder.style.display = 'none';
      if (previewImg) { previewImg.src = ev.target.result; previewImg.style.display = 'block'; }
      if (uploadLabel) uploadLabel.style.display = 'none';
    };
    reader.readAsDataURL(file);
  });
}

// card 3D tilt on mouse
const card3d = document.getElementById('tcg-card');
const wrap3d = document.getElementById('card-3d-wrap');
if (wrap3d && card3d) {
  wrap3d.addEventListener('mousemove', (e) => {
    const r = wrap3d.getBoundingClientRect();
    const x = (e.clientX - r.left) / r.width  - 0.5;
    const y = (e.clientY - r.top)  / r.height - 0.5;
    card3d.style.transform = `rotateY(${x * 18}deg) rotateX(${-y * 18}deg)`;
    // holo shimmer
    const holo = document.getElementById('tcg-holo');
    if (holo) holo.style.background = `radial-gradient(circle at ${(x+.5)*100}% ${(y+.5)*100}%, rgba(255,255,255,.25) 0%, transparent 60%)`;
  });
  wrap3d.addEventListener('mouseleave', () => {
    card3d.style.transform = '';
    const holo = document.getElementById('tcg-holo');
    if (holo) holo.style.background = '';
  });
}

updateCard();

/* ─────────────────────────────────────────
   DESIGN MODE: Shopify Theme Editor
   Reveal all animated elements immediately
   since IntersectionObserver doesn't fire
──────────────────────────────────────── */
function revealAll() {
  document.querySelectorAll('.rv,.rv-left,.rv-right').forEach(el => el.classList.add('in'));
  document.querySelectorAll('.feat').forEach(el => el.classList.add('in'));
  document.querySelectorAll('.review').forEach(el => el.classList.add('in'));
  document.querySelectorAll('.price-card').forEach(el => el.classList.add('in'));
  document.querySelectorAll('.how-step').forEach(el => el.classList.add('in'));
  document.querySelectorAll('.checklist li').forEach(el => el.classList.add('in'));
  document.querySelectorAll('.gallery-item').forEach(el => el.classList.add('in'));
  document.querySelectorAll('.word-inner').forEach(el => { el.style.transform = 'translateY(0)'; });
}

if (window.Shopify && window.Shopify.designMode) {
  revealAll();
  document.addEventListener('shopify:section:load', revealAll);
  document.addEventListener('shopify:section:select', revealAll);
  document.addEventListener('shopify:block:select', revealAll);
}

/* ─────────────────────────────────────────
   FAQ ACCORDION
──────────────────────────────────────── */
/* ─────────────────────────────────────────
   IMMEDIATE VIEWPORT REVEAL
   Reveal all animated elements that are already
   visible on page load — fixes the "white sections"
   on the live site (no shopify-design-mode class).
──────────────────────────────────────── */
(function immediateReveal() {
  const inView = el => {
    const r = el.getBoundingClientRect();
    return r.top < window.innerHeight + 100 && r.bottom > -100;
  };
  const selectors = [
    '.feat', '.review', '.how-step', '.price-card',
    '.gallery-item', '.rv', '.rv-left', '.rv-right'
  ];
  selectors.forEach(sel => {
    document.querySelectorAll(sel).forEach(el => {
      if (inView(el)) el.classList.add('in');
    });
  });
  // also reveal split-content checklist items in view
  document.querySelectorAll('.split-content').forEach(sc => {
    if (inView(sc)) {
      sc.querySelectorAll('.checklist li').forEach((li, i) =>
        setTimeout(() => li.classList.add('in'), 300 + i * 90));
    }
  });
  // reveal word-inner spans if h2 is already in view
  document.querySelectorAll('.word-inner').forEach(el => {
    if (inView(el)) el.style.transform = 'translateY(0)';
  });
})();

/* ─────────────────────────────────────────
   FAQ ACCORDION
──────────────────────────────────────── */
document.querySelectorAll('.faq-q').forEach(btn => {
  btn.addEventListener('click', () => {
    const item = btn.closest('.faq-item');
    const wasOpen = item.classList.contains('open');
    document.querySelectorAll('.faq-item').forEach(i => i.classList.remove('open'));
    if (!wasOpen) item.classList.add('open');
  });
});
